import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { EventsActionTypes } from './types'
import { fetchError, fetchSuccess, fetchByNameSuccess, fetchByNameError } from './actions'
import { db } from '../../components/firebase'
import StringHelper from '../../utils/StringHelper'
//import Convert from '../../utils/Convert'
import { utils } from 'redux-saga'
import RegExUtils from '../utils/RegExUtils'

// import login from '../../data/login.json'
// import project from '../../data/project.json'
// import events from '../../data/events.json'
// import blogs from '../../data/blog.json'
// import images from '../../data/images.json'
// import galleries from '../../data/imagegallery.json'
// import directories from '../../data/directoriesEvents.json'

function FindPreviousItemPromise(item: any) {
  let promise = () =>
    db
      .FindPreviousEvent(item.startDate)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}
function FindNextItemPromise(item: any) {
  item = item == null ? 0 : item

  let promise = () =>
    db
      .FindNextEvent(item.startDate)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function getPromiseByName(name: string) {
  let promise = () =>
    db
      .GetEventByName(name)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function* handleImage(id: number) {
  try {
    let promise = () =>
      db
        .findImage(id)
        .get()
        .then(snapshot =>
          snapshot.docs.map(doc => {
            return doc.data()
          })
        )
    const res = yield promise()
    yield put(fetchSuccess(res))
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}
function saveLogin() {
  login.map((o: any) => {
    db.onceUsers().add(o)
  })
}
function getEventPromise() {
  let promise = () =>
    db
      .onceEvents()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}
function getImagePromise() {
  let promise = () =>
    db
      .onceImages()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function decorateImage(event: any, images: any) {
  // Consolidate - e.g. add info
  const storageRef = db.storageRef()
  event.map((item: any, index: number) => {
    // update author data if not there
    if (item.data().cover == undefined) {
      // How do we update document with details
      let u: any = images.find((image: any) => image.data().id == item.data().mainimage)
      if (u != undefined) {
        const image = storageRef.child(u.data().location.replace('~', ''))
        image.getDownloadURL().then(url => {
          console.log('url', url)
          // update item with author data
          db.GetEventDoc(item.id)
            .update({
              cover: {
                description: u.data().description,
                location: u.data().location,
                id: u.data().id,
                url: url
              }
            })
            .then(function() {
              console.log('Document successfully updated!')
            })
        })
      }
    } else {
      console.log('cover already defined')
    }
  })
}

function* FindStorageURL(storageRef: any, str: string) {
  console.log('FindStorageURL', str)
  let image = storageRef.child(str)
  let promise = () =>
    image.getDownloadURL().then(url => {
      // console.log(url)

      return {
        url,
        str
      }
    })
  const result = yield promise()
  return result
}
function* updateURL(item: any) {
  let name = item.data().name
  // console.log(name)
  name = StringHelper(name)
  // console.log(name)
  db.GetEventDoc(item.id)
    .update({
      url_name: name
    })
    .then(function() {
      console.log(
        'updateURL ',
        item.data().name,
        item.data().url_name,
        name,
        ' successfully updated!'
      )
    })
}
function* bulkUpdate() {
  console.log('bulkUpdate')
  const events = yield call(getEventPromise)

  // const result = yield call(updateEventConvertBodyToPage, events[0])
  for (let event of events) {
    // const result = yield call(updateEventByUploadingImagesAndReplaceBody, event)
    // const result = yield call(updateEventConvertBodyToPage, event)
    const result = yield call(updateURL, event)
  }
  // const results = yield all(calls)
  // yield put(fetchSuccess(results))
}

function urlTransformer(url) {
  return url
}

function classIdTransformer(name) {
  return name
}
function* updateEventConvertBodyToPage(event: any) {
  console.log('updateEventConvertBodyToPage', event.data().name, event.data().id)
  const mediaPattern = RegExUtils.mediaPattern;
  const splitPattern = RegExUtils.splitPattern;
  const labelPattern = RegExUtils.label;
  const titlePattern = RegExUtils.titlePattern;
  const removePatterns = RegExUtils.removePatterns;
  let body = event.data().body
  Convert.GetValuesInBody(body);

  let mediaMatch = body.match(mediaPattern)
  let titleMatch = body.match(labelPattern)
  let mediaArr = []
  //match up all media
  if (mediaMatch != null) {
    for (let i = 0; i < mediaMatch.length; i++) {
      // add a split patterns into the body
      body = body.replace(mediaMatch[i], splitPattern)
      let media = mediaMatch[i]
      let src =
        media.match(RegExUtils.imagePattern) != null
          ? media.match(RegExUtils.imagePattern)[0]
          : ''
      let alt =
        media.match(RegExUtils.altPattern) != null
          ? media.match(RegExUtils.altPattern)[0]
          : ''
      let mediaType = 'image'
      if (src.indexOf('youtube') != -1) {
        mediaType = 'youtube'
      } else if (src.indexOf('vimeo') != -1) {
        mediaType = 'vimeo'
      }
      let mediaObj = {
        type: mediaType,
        url: src,
        label: mediaType == 'image' ? alt : titleMatch != null ? titleMatch[i] : ''
      }
      mediaArr.push(mediaObj)
    }
  }
  //split the body into pages
  let pageArrX = body.split(splitPattern)
  let pageArr = []
  //clear out empty parts
  for (let i = 0; i < pageArrX.length; i++) {
    let p = RegExUtils.Sanitize(pageArrX[i]);
    let trimmed = p.replace(/<.*?>/gi, '').trim()
    console.log('p', trimmed == '', trimmed)
    if (trimmed != '') {
      pageArr.push(p)
    }
  }

  var pages = []

  for (let i = 0; i < pageArr.length; i++) {
    let pageBody = pageArr[i]
    pageBody = RegExUtils.Sanitize(pageBody.replace(labelPattern, '');
    console.log('page', pageBody)
    let title = ''
    if (pageBody.match(titlePattern) != null) {
      title = pageBody.match(titlePattern).length != -1 ? pageBody.match(titlePattern)[0] : ''
    }
    title = title.replace(/<br>/gi, '')
    let obj = {
      theme: i % 2 == 0 ? 'light' : 'dark',
      title: title,
      subtitle: '',
      body: pageBody
    }
    if (mediaArr[i] != undefined) {
      obj['media'] = mediaArr[i]
    }
    pages.push(obj)
  }
  db.GetEventDoc(event.id)
    .update({
      pages: pages,
      cover: pages[0].hasOwnProperty('media') ? pages[0].media : undefined
    })
    .then(function() {
      console.log('Document ' + event.data().name + ' successfully updated!')
    })
  console.log(pages)
  return pages
}
function* updateEventByUploadingImagesAndReplaceBody(event: any) {
  console.log('updateEvent', event)
  const regex = /(userdata\/)([\/|.|\w|\s|-])*\.(?:jpg|gif|png)/gi
  const storageRef = db.storageRef()
  const replaceLower = directories
  let imagesToReplace = []
  let images = []

  if (event.data().body.match(regex) != null) {
    let str = ''
    event
      .data()
      .body.match(regex)
      .map(m => {
        str = m
        replaceLower.map(folder => {
          str = str.replace('/' + folder + '/', '/' + folder.toLowerCase() + '/')
        })
        if (str.indexOf('/sonicimpairment/') != -1) {
          str = str.replace('/sonicimpairment/', '/events/sonicimpairment/')
        }
        imagesToReplace.push({ updated: str, original: m })
        // calls.push(call(FindStorageURL(storageRef, str)()))
      })
    console.log(imagesToReplace)
    let imageStorage = []
    for (let img of imagesToReplace) {
      const result = yield call(FindStorageURL, storageRef, img.updated)
      result.original = img.original
      imageStorage.push(result)
    }

    // console.log(storageRef, str, result)
    let body = event.data().body
    for (let i of imageStorage) {
      body = body.replace(i.original, i.url)
    }
    images.push({ images: imageStorage, event: event, body: body })
  }

  images.map(item => {
    console.log(item.body)

    db.GetEventDoc(item.event.id)
      .update({
        body_old:
          item.event.data().body_old == null ? item.event.data().body : item.event.data().body_old,
        body: item.body
      })
      .then(function() {
        console.log('Document ' + item.event.name + ' successfully updated!')
      })
  })
}
function getUsersPromise() {
  let promise = () =>
    db
      .onceUsers()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}
function* handleFetch() {
  // saveLogin()
  // console.log('handle event')
  try {
    const res = yield getEventPromise()
    // const resUser = yield getUsersPromise()
    // // const resImages = yield getImagePromise()
    // res.map((item: any, index: number) => {
    //   if (item.data().author == undefined) {
    //     // How do we update document with author details
    //     let u: any = resUser.find((user: any) => user.data().id == item.data().authorid)
    //     if (u != undefined) {
    //       // update item with author data

    //       db.GetEventDoc(item.id)
    //         .update({
    //           author: {
    //             name: u.data().name,
    //             email: u.data().email,
    //             profile: u.data().profile
    //           }
    //         })
    //         .then(function() {
    //           console.log('Document successfully updated!')
    //         })
    //     }
    //   } else {
    //     console.log('author already defined')
    //   }
    // })
    // console.log(res)
    // console.log(resUser)
    // console.log(resImages)
    yield put(fetchSuccess(res.map(item => item.data())))
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* handleFetchByName({ payload }) {
  try {
    const res = yield getPromiseByName(payload.name)

    // const resUser = yield getUsersPromise()
    let out = res.map(item => item.data())
    if (out[0] != undefined) {
      if (out[0].hasOwnProperty('url_name')) {
        // console.log('out[0]', out[0])
        const next = yield FindNextItemPromise(out[0])
        const previous = yield FindPreviousItemPromise(out[0])
        if (next[0] != null) out[0].next = next[0].data()
        if (previous[0] != null) out[0].previous = previous[0].data()
      }
      yield put(fetchByNameSuccess(out[0]))
    } else {
      yield put(fetchByNameError('no data found'))
    }
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      yield put(fetchByNameError(err.stack!))
    } else {
      yield put(fetchByNameError('An unknown error occured.'))
    }
  }
}
function* bulkTransfer() {
  console.log('handle')
  try {
    let promise = () =>
      db
        .onceGetFirestoreProject()
        .get()
        .then(querySnapshot => {
          let p: any = []
          querySnapshot.docs.map(doc => p.push(doc.data()))
          return p
        })
    const res = yield promise()
    yield put(fetchSuccess(res))
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* watchFetchByNameRequest() {
  yield takeEvery(EventsActionTypes.FETCH_BY_NAME_REQUEST, handleFetchByName)
}

function* watchBulkTransferRequest() {
  yield takeEvery(EventsActionTypes.BULK_TRANSFER, bulkTransfer)
}

function* watchBulkRequest() {
  // console.log('watchBulkRequest ', arguments)
  yield takeEvery(EventsActionTypes.BULK_UPDATE, bulkUpdate)
}
// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
  yield takeEvery(EventsActionTypes.FETCH_REQUEST, handleFetch)
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* EventsSaga() {
  yield all([
    fork(watchFetchRequest),
    fork(watchFetchByNameRequest),
    fork(watchBulkRequest),
    fork(watchBulkTransferRequest)
  ])
}

export default EventsSaga
